import { useCallback, useRef } from 'react';

// NOTE: Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
export function useInteractiveCallback<T extends (...args: any[]) => any>(
    callback: T,
): T {
    const ref = useRef<T | undefined>(undefined);

    ref.current = callback;

    return useCallback(
        ((...args: Parameters<T>) => ref.current?.apply(undefined, args)) as T,
        [],
    );
}
